import { useMutation, useQuery } from 'react-query'
import { useMainContext } from '../../contexts/main'
import { filterFetch, normalFetch } from '../fetch-api/get'
import { postApiWithToken } from '../fetch-api/post'
import { useQueryContext } from '../../contexts/query'

const useAvailableCoinTokensQuery = (coin, onSuccessNetwork) => {
	const {
		profile: { token },
	} = useMainContext()

	return useQuery(
		'fetch-coin-tokens',
		() => normalFetch(token, `crypto/tokens?search=symbol&query=${coin ? coin : ''}`),
		{
			enabled: false,
			refetchOnWindowFocus: false,
			select: (res) => res.data,
			onSuccess: onSuccessNetwork,
		}
	)
}

const useDepositMutation = (onDepositSuccess = () => { }) => {
	const {
		profile: { token },
	} = useMainContext()

	return useMutation('deposit-coin', (data) => postApiWithToken(data, token, 'coining/deposit'), {
		onSuccess: onDepositSuccess,
	})
}

const useWithdrawMutation = ({ callback } = {}) => {
	const {
		profile: { token },
	} = useMainContext()
	const { setToast } = useQueryContext()
	return useMutation('withdraw-coin', (data) => postApiWithToken(data, token, 'coining/withdraw'), {
		onSuccess: () => {
			callback?.()

			setToast({
				isError: false,
				show: true,
				message: 'op-success',
			})
		},
	})
}

const useBankDepositMutation = (onSuccess) => {
	const {
		profile: { token },
	} = useMainContext()

	return useMutation('deposit-bank', (data) => postApiWithToken(data, token, 'banking/deposit'), {
		onSuccess,
	})
}

const useBankWithdrawMutation = ({ callback } = {}) => {
	const {
		profile: { token },
	} = useMainContext()
	const { setToast } = useQueryContext()

	return useMutation('withdraw-bank', (data) => postApiWithToken(data, token, 'banking/withdraw'), {
		onSuccess: () => {
			callback?.()

			setToast({
				isError: false,
				show: true,
				message: 'op-success',
			})
		},
	})
}

const useGetAccountingConfigs = () => {
	const {
		profile: { token },
	} = useMainContext()

	return useQuery('accounting-configs', () => normalFetch(token, `settings/manualAccounting`), {
		refetchOnWindowFocus: false,
		select: (res) => res?.data?.data,
	})
}

const useManualTransferMutation = (type, callback) => {
	const {
		profile: { token },
	} = useMainContext()
	const { setToast } = useQueryContext()

	return useMutation(
		['manual-transfer', type],
		(data) => postApiWithToken(data, token, `banking/manual/${type}`),
		{
			onSuccess: () => {
				callback?.()

				setToast({
					isError: false,
					show: true,
					message: 'op-success',
				})
			},
		}
	)
}

const useGetAccountingList = (params) => {
	const {
		profile: { token },
	} = useMainContext()

	return useQuery({
		queryFn: () => filterFetch(params, token, 'banking'),
		queryKey: ['accounting-history', params],
		select: (res) => res?.data,
	})
}

const useGetOwnerAccounts = () => {
	const {
		profile: { token },
	} = useMainContext()

	return useQuery({
		queryFn: () => normalFetch(token, 'settings/ownerAccount'),
		queryKey: ['owner-accounts0'],
		select: (res) => res?.data?.data,
		staleTime: 5 * 60 * 1000,
		cacheTime: 5 * 60 * 1000,
	})
}

const useUploadFile = () => {
	const {
		profile: { token },
	} = useMainContext()
	const { setToast } = useQueryContext()

	return useMutation(
		['manual-transfer-file'],
		(data) => postApiWithToken(data, token, `files/upload`),
		{
			onSuccess: () => {
				setToast({
					isError: false,
					show: true,
					message: 'op-success',
				})
			},
		}
	)
}

export {
	useAvailableCoinTokensQuery,
	useDepositMutation,
	useWithdrawMutation,
	useBankWithdrawMutation,
	useBankDepositMutation,
	useGetAccountingConfigs,
	useManualTransferMutation,
	useGetAccountingList,
	useGetOwnerAccounts,
	useUploadFile
}
